import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ContentSection } from "@fabric-types/svc-content";
import { Store } from "@ngrx/store";
import { CoreState } from "@obg/ngx.core";
import { CoreContentState } from "@obg/ngx.core.content";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { RouteSelector } from "@obg/ngx.router";
import { kebabCase, unescape } from "lodash-es";

@Component({
	selector: "obg-content-section-group",
	templateUrl: "./content-section-group.component.html",
	styleUrls: ["./content-section-group.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ContentSectionGroupComponent {
	@HostBinding("class.obg-content-section-group") hostCssClass = true;

	@Input() contentSections: ContentSection[] | undefined;

	@Input()
	@coerceBoolean()
	anchorLinksVisible = true;

	@Input()
	@coerceBoolean()
	seoEnabled = false;

	@Input()
	@coerceBoolean()
	hideTitles = false;

	currentPathName$ = this.store.select(RouteSelector.getCurrentPathName);

	constructor(
		private domSanitizer: DomSanitizer,
		private store: Store<CoreState & CoreContentState>
	) {}

	encode(text: string): string {
		return kebabCase(text.toLowerCase());
	}

	// todo: remove this when CRS starts supporting name attribute
	getRawSafeHtml(text: string): SafeHtml {
		return this.domSanitizer.bypassSecurityTrustHtml(unescape(text));
	}

	contentSectionTrackBy(_index: number, contentSection: ContentSection): string {
		return contentSection.documentKey;
	}
}
